export const iconFontAwesomeFruitsVegetablesSeedling = (
	<i className="fa-solid fa-seedling"></i>
);
